export const BASE_API_DATE_FORMAT = 'YYYY-MM-DD'
